import type { Components } from '@mui/material';

export const MuiDialogTitle: Components['MuiDialogTitle'] = {
  styleOverrides: {
    root: {
      padding: 0,
      fontSize: '1.5rem',
      color: '#000',
      marginBottom: '8px',
    },
  },
};